// extracted by mini-css-extract-plugin
module.exports = {"floatButton":"tooltip_floatButton__26PaM","floatButtonText":"tooltip_floatButtonText__2P9W_","floatButtonAlt":"tooltip_floatButtonAlt__qd6Hx"};